import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { CONTACT } from "../lib/data";

export default function CallButton() {
  return (
    <motion.a
      href={CONTACT.phoneHref}
      data-testid="floating-call-button"
      aria-label="Appeler le camping"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
      className="lg:hidden fixed bottom-5 right-5 z-50 grid place-items-center w-14 h-14 rounded-full bg-terra text-sand shadow-2xl shadow-terra/40 active:scale-90 transition-transform duration-200"
    >
      <span className="absolute inset-0 rounded-full bg-terra animate-ping opacity-25" />
      <Phone size={22} className="relative" />
    </motion.a>
  );
}
